import { render, staticRenderFns } from "./SignUp.vue?vue&type=template&id=360a4537"
import script from "./SignUp.js?vue&type=script&lang=js&external"
export * from "./SignUp.js?vue&type=script&lang=js&external"
import style0 from "./SignUp.vue?vue&type=style&index=0&id=360a4537&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports